import PatrolReport from '@/app/patrol-report'
import { ability } from '@/casl/ability'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <PatrolReport />
}

export const Route = createFileRoute('/_auth/_withProject/patrol-report')({
  beforeLoad: ({ context }) => {
    if (
      ability &&
      context.auth.user &&
      !ability.can('read', 'Devriye Raporu')
    ) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  component: RouteComponent,
})


